export const SCRIPTS_SLICE_NAME = 'scripts';

export enum ScriptReplacementKey {
  ChildName = 'childName',
  IncorrectWord = 'incorrectWord',
  ReversedLetter = 'reversedLetter',
  IncorrectLetter = 'incorrectLetter',
}

export interface ScriptsState {
  replacements: Partial<Record<ScriptReplacementKey, string>>;
}

export interface SetScriptReplacementPayload {
  key: ScriptReplacementKey;
  value: string;
}
